module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"the-savant-guard\"-in-pasadena-california-041d6e52db1cfcda794c395f5eea7d9d.png";